/**
 * Returns true if any course slot on the cohort is currently publishing.
 * Used only to decide whether to refetch — does not resolve product states.
 */
const hasPublishingCourse = (cohort) => {
  if (!cohort) {
    return false;
  }

  return [cohort.prework, cohort.course, cohort.career_services]
    .filter(Boolean)
    .some((course) => course.publication && course.publication.status === 'publishing');
};

export default hasPublishingCourse;
